/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BADGE_TYPE_STRONG, Badge } from '@squiz/sds';
import React from 'react';
import { validateComponentType } from '../ValidateComponentType/ValidateComponentType';

/**
 * Component badge type props.
 */
export type ComponentTypeBadgeProps = {
  componentType: string | undefined;
};
/**
 * Component badge type component.
 * @param {ComponentTypeBadgeProps} props Props passed to `<ComponentTypeBadge />`.
 * @export
 * @returns {JSX.Element} The `<ComponentTypeBadge />` component.
 */
export const ComponentTypeBadge = (props: ComponentTypeBadgeProps): JSX.Element => {
  const componentType = validateComponentType(props.componentType);

  return <Badge left={componentType} type={BADGE_TYPE_STRONG} />;
};
